import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _PersonIcon;
var _excluded = ["user"];
import React, { Fragment, memo } from 'react';
import MuiAvatar from "@mui/material/Avatar/Avatar.js";
import Tooltip from "@mui/material/Tooltip/Tooltip.js";
import PersonIcon from "@mui/icons-material/esm/Person.js";
import { lighten, styled } from '@mui/material/styles/index.js';
import { getUserInitials } from "./utils.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Avatar = styled(MuiAvatar)(function (_ref) {
  var theme = _ref.theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var sizeStyles = {
    large: {
      fontSize: theme.spacing(3),
      width: theme.spacing(6),
      height: theme.spacing(6)
    },
    medium: {
      fontSize: theme.spacing(2.5),
      width: theme.spacing(5),
      height: theme.spacing(5)
    },
    small: {
      fontSize: theme.spacing(2),
      width: theme.spacing(4),
      height: theme.spacing(4)
    },
    xsmall: {
      fontSize: theme.spacing(1.5),
      width: theme.spacing(3),
      height: theme.spacing(3)
    }
  };
  var color = theme.palette.primary.lighter;
  var mainBg = lighten(theme.palette.teal[900], 0.3);
  var accentBg = theme.palette.teal[900];
  return _extends({}, sizeStyles[size], {
    fontWeight: theme.typography.fontWeightMedium,
    background: "linear-gradient(138.09deg, ".concat(mainBg, " 55%, ").concat(accentBg, " 100%)"),
    color: color
  });
});

/**
 * Avatar representing a logged in Planet user
 */
export var UserAvatar = function UserAvatar(_ref2) {
  var user = _ref2.user,
    props = _objectWithoutProperties(_ref2, _excluded);
  var userInitials = getUserInitials(user);
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom",
    disableHoverListener: !user,
    title: user != null && user.name || user != null && user.email ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: user.name
      }), /*#__PURE__*/_jsx("div", {
        children: user.email
      })]
    }) : '',
    children: /*#__PURE__*/_jsx(Avatar, _extends({
      "data-qe": "user-avatar"
    }, props, {
      children: userInitials || _PersonIcon || (_PersonIcon = /*#__PURE__*/_jsx(PersonIcon, {}))
    }))
  });
};
export default /*#__PURE__*/memo(UserAvatar);